import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';

import HotelContacts from './HotelContacts';
import MapWidget from './MapWidget';
import Photos from './Photos';
import PropertyOverview from './PropertyOverviewContainer';
import PropertyDescription from './PropertyDescription';
import HotelSpecialOffer from './HotelSpecialOffer';
import PropertyDetails from './PropertyDetails';
import PropertyHours from './PropertyHours';
import PropertyFeatures from './PropertyFeatures';
import Landmarks from "./Landmarks";
import Rooms from "./Rooms"
import HotelDocuments from "./HotelDocuments"
class HotelDetailView extends React.Component {
  render() {
    const hotel = this.props.hotel;

    const enableHours = false;

    return (
      <div className="container-fluid hotel-detail-container">
        <div className="row">
          <div className="col-md-12 hotel-detail-header">
            <h1>{hotel.name}</h1>
            <hr />
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <h1 className="hotel-detail-subhead">Property Overview</h1>
          </div>
          <PropertyOverview hotel={hotel} editHotel={this.props.editHotel} />
        </div>
        <div className="row">
          <div className="col-md-6">
              <HotelContacts
                hotel={hotel}
                addHotelContact={this.props.addHotelContact}
                removeHotelContact={this.props.removeHotelContact}
              />
            </div>
        </div>
        <div className="row hotel-detail-map">
          <MapWidget hotel={hotel} />
        </div>
        <div className="row">
          <div className="col-md-12">
            <h1 className="hotel-detail-subhead">Property Details</h1>
            <HotelSpecialOffer hotel={hotel} editHotel={this.props.editHotel} />
            <PropertyDescription hotel={hotel} editHotel={this.props.editHotel} />
            <HotelDocuments hotel={hotel} editHotel={this.props.editHotel} addHotelDocument={this.props.addHotelDocument} deleteHotelDocument={this.props.deleteHotelDocument} updateHotelDocument={this.props.updateHotelDocument}/>
            <PropertyDetails hotel={hotel} editHotel={this.props.editHotel} />
          </div>
        </div>
        {enableHours && (
          <div className="row">
            <div className="col-md-12">
              <h1 className="hotel-detail-subhead">Hours</h1>
              <PropertyHours hotel={hotel} />
            </div>
          </div>
        )}
        <Photos
          hotel={hotel}
          editHotelPhoto={this.props.editHotelPhoto}
          addHotelPhoto={this.props.addHotelPhoto}
          removeHotelPhoto={this.props.removeHotelPhoto}
          sortHotelPhotos={this.props.sortHotelPhotos}
          ishotelEditView={true}
        />
        <PropertyFeatures hotel={hotel} editHotelFeatures={this.props.editHotelFeatures} />
        <Landmarks hotel={hotel} editLandmark={this.props.editLandmark} removeLandmark={this.props.removeLandmark} postHotelAddLandmark={this.props.postHotelAddLandmark} />
        <Rooms hotel={hotel}
          sortHotelPhotos={this.props.sortHotelPhotos}
          removeHotelPhoto={this.props.removeHotelPhoto}
          editHotelPhoto={this.props.editHotelPhoto}
          removeRoomType={this.props.removeRoomType}
          editHotel={this.props.editHotel}
          editRoomtypes={this.props.editRoomtypes}
          addHotelAddRoomType={this.props.addHotelAddRoomType}
          addAddHotelRoomPhoto={this.props.addAddHotelRoomPhoto}
          removeRoomPhoto={this.props.removeRoomPhoto}
        />
      </div>
    );
  }
}

HotelDetailView.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotel: PropTypes.func.isRequired,
  editHotelFeatures: PropTypes.func.isRequired,
  addHotelContact: PropTypes.func.isRequired,
  removeHotelContact: PropTypes.func.isRequired,
  addHotelPhoto: PropTypes.func.isRequired,
  editHotelPhoto: PropTypes.func.isRequired,
  removeHotelPhoto: PropTypes.func.isRequired,
  sortHotelPhotos: PropTypes.func.isRequired,
};

export default HotelDetailView;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelDetailView.js